/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(require('babel-runtime/helpers/extends'));
var circleStyle = _interopDefault(require('./circle-style'));
var clusterSource = _interopDefault(require('./cluster-source'));
var feature = _interopDefault(require('./feature'));
var fillStyle = _interopDefault(require('./fill-style'));
var geoloc = _interopDefault(require('./geoloc'));
var iconStyle = _interopDefault(require('./icon-style'));
var lineStringGeom = _interopDefault(require('./line-string-geom'));
var map = _interopDefault(require('./map'));
var mapboxSource = _interopDefault(require('./mapbox-source'));
var multiLineStringGeom = _interopDefault(require('./multi-line-string-geom'));
var multiPointGeom = _interopDefault(require('./multi-point-geom'));
var multiPolygonGeom = _interopDefault(require('./multi-polygon-geom'));
var osmSource = _interopDefault(require('./osm-source'));
var overlay = _interopDefault(require('./overlay'));
var pointGeom = _interopDefault(require('./point-geom'));
var polygonGeom = _interopDefault(require('./polygon-geom'));
var regShapeStyle = _interopDefault(require('./reg-shape-style'));
var selectInteraction = _interopDefault(require('./select-interaction'));
var sputnikSource = _interopDefault(require('./sputnik-source'));
var strokeStyle = _interopDefault(require('./stroke-style'));
var styleBox = _interopDefault(require('./style-box'));
var styleContainer = _interopDefault(require('./style-container'));
var styleFunc = _interopDefault(require('./style-func'));
var textStyle = _interopDefault(require('./text-style'));
var tileLayer = _interopDefault(require('./tile-layer'));
var vectorLayer = _interopDefault(require('./vector-layer'));
var vectorSource = _interopDefault(require('./vector-source'));
var wmsSource = _interopDefault(require('./wms-source'));
var wmtsSource = _interopDefault(require('./wmts-source'));
var xyzSource = _interopDefault(require('./xyz-source'));
var core = require('./core');
var _Object$keys = _interopDefault(require('babel-runtime/core-js/object/keys'));



var components = Object.freeze({
	CircleStyle: circleStyle,
	ClusterSource: clusterSource,
	Feature: feature,
	FillStyle: fillStyle,
	Geoloc: geoloc,
	IconStyle: iconStyle,
	LineStringGeom: lineStringGeom,
	Map: map,
	MapboxSource: mapboxSource,
	MultiLineStringGeom: multiLineStringGeom,
	MultiPointGeom: multiPointGeom,
	MultiPolygonGeom: multiPolygonGeom,
	OsmSource: osmSource,
	Overlay: overlay,
	PointGeom: pointGeom,
	PolygonGeom: polygonGeom,
	RegShapeStyle: regShapeStyle,
	SelectInteraction: selectInteraction,
	SputnikSource: sputnikSource,
	StrokeStyle: strokeStyle,
	StyleBox: styleBox,
	StyleContainer: styleContainer,
	StyleFunc: styleFunc,
	TextStyle: textStyle,
	TileLayer: tileLayer,
	VectorLayer: vectorLayer,
	VectorSource: vectorSource,
	WmsSource: wmsSource,
	WmtsSource: wmtsSource,
	XyzSource: xyzSource
});

/**
 * Registers all VueLayers components.
 * @param {Vue} Vue
 */
function install(Vue) {
  if (install.installed) return;
  install.installed = true;

  // install all components
  _Object$keys(components).forEach(function (key) {
    if (typeof components[key].install === 'function') {
      Vue.use(components[key]);
    }
  });
}

/**
 * Entry file for non-ES environments.
 */
// import lib style
var VueLayers = _extends({
  // meta & consts
  VERSION: '0.7.5',
  // install
  install: install,
  core: core
}, components);

module.exports = VueLayers;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/index.js
// module id = 1183
// module chunks = 1